import { StyleSheet } from 'aphrodite'

import main from './main'
import top from './top'
import bottom from './bottom'

export default {
  main: StyleSheet.create(main),
  top: StyleSheet.create(top),
  bottom: StyleSheet.create(bottom)
}



// WEBPACK FOOTER //
// ./src/components/partials/Footer/style/index.js